import React from 'react';
import dice3 from "../../../Assets/Images/dice-3.svg";
import vertcaldots from "../../../Assets/Images/vertical-dots.svg";

export default function Table() {
  const sampledata = [
    {
      "Header Column": "Row Item",
      "Single tag": "Single tag",
      "dice": 2.8,
      "Basic W/ Sub": ["Data item", "Sub-Item Detail"],
      "Basic Data": "Data item",
      "Percentage": 80,
      "All caps": "ALL CAPS",
      "Multi-tag": ["Retired", "Student", "SAHP"]
    },
    {
      "Header Column": "Row Item",
      "Single tag": "Single tag",
      "dice": 2.8,
      "Basic W/ Sub": ["Data item", "Sub-Item Detail"],
      "Basic Data": "Data item",
      "Percentage": 86,
      "All caps": "ALL CAPS",
      "Multi-tag": ["Retired", "Student", "SAHP"]
    },
  ];

  return (
    <div className='container table'>
      <table>
        <thead className="table-header">
          <tr>
            <th className='left-b'>Header Column</th>
            <th style={{ minWidth: "120px" }}>Single tag</th>
            <th><img src={dice3} alt="dice" /></th>
            <th style={{ minWidth: "170px" }}>Basic W/ Sub</th>
            <th style={{ minWidth: "82px" }}>Basic Data</th>
            <th style={{ minWidth: "160px" }}>Percentage</th>
            <th style={{ minWidth: "120px" }}>All caps</th>
            <th>Multi-tag</th>
            <th style={{ minWidth: "26px" }} className='left-border'></th>
          </tr>
        </thead>
        <tbody>
          {
            sampledata.map((data, index) => {
              return (
                <tr key={index}>
                  <td className='left-b'><p >{data["Header Column"]}</p></td>
                  <td><p className='singletag'>&nbsp;{data["Single tag"]}</p></td>
                  <td><p className='dice'>{data["dice"]}</p></td>
                  <td>
                    <div className='Basicw'>
                      <p>{data["Basic W/ Sub"][0]}</p>
                      <p style={{color:"rgba(122, 122, 157, 1)"}}>{data["Basic W/ Sub"][1]}</p>
                      </div>
                  </td>
                  <td ><p>{data["Basic Data"]}</p></td>
                  <td>
                    <div className='percentagerow'>
                      <p >{data["Percentage"]}%</p>
                      <div className="percentagecol">
                        <div className="persentage" style={{width:`${data["Percentage"]}%`}}></div>
                      </div>
                    </div>
                  </td>
                  <td><p className='allcaps'>{data["All caps"]}</p></td>
                  <td>
                    <div className='tag'>
                      <div className="tag1 basic-tag">{data["Multi-tag"][0]}</div>
                      <div className="tag2 basic-tag">{data["Multi-tag"][1]}</div>
                      <div className="tag3 basic-tag">{data["Multi-tag"][2]}</div>
                    </div>
                  </td>
                  <td className='left-border'><img src={vertcaldots} alt="Dots" /></td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
}
